import React from "react";

import NavigationControls from "Common/NavigationControls";

const FooterNavigation = (props) => {
  return <NavigationControls MiddleContent={<>&nbsp;</>} {...props} />;
};

export default FooterNavigation;
